// Company and postal-entry details used by the terms, free entry and cookie
// pages. Taken from the current rendallscompetitions.co.uk terms (Oct 2026).
// Jason to confirm before launch.

export const COMPANY = {
  name: 'Rendalls Competitions Ltd',
  number: 'SC703083',
  registeredOffice: '28 Munnoch Way, Plean, Stirling, Stirlingshire, Scotland, FK7 8GA',
  email: 'info@rendallscompetitions.co.uk',
  website: 'www.rendallscompetitions.co.uk',
};

export const POSTAL_ENTRY_ADDRESS = [
  'Rendalls Competitions',
  '28 Munnoch Way',
  'Plean',
  'Stirling',
  'FK7 8GA',
];

// Shown when a competition has no question of its own; must match the
// fallback in PreCartQuestionnaire.
export const DEFAULT_COMPETITION_QUESTION = {
  question: 'General Knowledge: What is the capital of the United Kingdom?',
  options: [
    { value: 'london', label: 'London' },
    { value: 'manchester', label: 'Manchester' },
  ],
};

/** Question text and option labels only, never the answer. */
export function publicQuestion(raw) {
  let q = raw;
  if (typeof q === 'string') {
    try {
      q = JSON.parse(q);
    } catch {
      q = null;
    }
  }
  if (!q?.question || !Array.isArray(q?.options) || !q.options.length) {
    q = DEFAULT_COMPETITION_QUESTION;
  }
  return {
    question: q.question,
    options: q.options
      .map((o) => (typeof o === 'string' ? o : o?.label || o?.value))
      .filter(Boolean),
  };
}
